import React from "react";
import {
	Image,
	IconWrapper,
	Icon,
	Bar,
	Download,
	ServiceIcon,
	Text,
} from "./Appbar.style";
import { useNavigate } from "react-router-dom";
import { ServiceOutlined } from "@assets";
import { PUBLIC_ROUTE } from "@router/route.constants";
import { useTranslation } from "react-i18next";

const Appbar = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	// const [screenSize, setScreenSize] = useState({
	// 	width: window.innerWidth,
	// 	height: window.innerHeight,
	// });

	// useEffect(() => {
	// 	const handleResize = () => {
	// 		setScreenSize({
	// 			width: window.innerWidth,
	// 			height: window.innerHeight,
	// 		});
	// 	};

	// 	// Add event listener to update screen size on resize
	// 	window.addEventListener("resize", handleResize);

	// 	// Clean up event listener on component unmount
	// 	return () => {
	// 		window.removeEventListener("resize", handleResize);
	// 	};
	// }, []); // Empty dependency array ensures the effect runs only once

	const goToSearch = () => {
		navigate(`/${PUBLIC_ROUTE.SEARCH}`);
	};

	const goToDownload = () => {
		navigate(`/${PUBLIC_ROUTE.APP_DOWNLOAD}`);
	};

	const goToService = () => {
		navigate(`/home/${PUBLIC_ROUTE.MESSAGE}`);
	};

	const Logo = () => <Image />;

	const Icons = () => (
		<IconWrapper>
			<ServiceIcon onClick={goToService}>
				<ServiceOutlined />
				<Text>{t("common.service")}</Text>
				{/* {screenSize.width > 362 && <Text>{t("common.service")}</Text>} */}
			</ServiceIcon>
			<Icon onClick={goToSearch} />
			<Download onClick={goToDownload} />
		</IconWrapper>
	);

	return (
		<Bar>
			<Logo />
			<Icons />
		</Bar>
	);
};

export default Appbar;
